import { __rest } from "tslib";
import lodashGet from 'lodash/get';
export class ContactServerPersonal {
    constructor(ctx, common) {
        this.ctx = ctx;
        this.common = common;
    }
    async syncPersonContactList(options) {
        const { force = false, isMainAccount, _account } = options;
        const from = 'personal';
        try {
            const params = await this.common.getSyncServerParams({
                from,
                force,
                isMainAccount,
                _account,
            });
            const url = this.ctx.systemApi.getUrl(this.common.getServerUrl(from, params));
            const { personContactVOList: list = [], lastUpdateTime } = await this.common.excuteContactServerWithRetry({
                url,
                params,
                isMainAccount,
                _account,
            }, force ? {} : { correctCodes: [0, 106000, 107000] });
            await this.ctx.contactDB.personalAllInto({
                list,
                force,
                isMainAccount,
                _account,
            });
            this.ctx.contactUtil.setStoreContactSyncPageInfo({
                from,
                domain: this.common.getDomain(options._account) || '',
                step: force ? 'all' : 'increase',
                done: true,
                source: 'unknown',
                lastUpdateTime,
                isMainAccount,
                _account,
            });
            return {
                success: true,
                data: [],
                from,
                count: lodashGet(list, 'length', 0),
                _account,
            };
        }
        catch (ex) {
            return {
                from,
                success: false,
                data: [],
                message: ex instanceof Error ? ex.message : `${ex}`,
            };
        }
    }
    async syncPersonalOrgList(options) {
        const { force, isMainAccount, _account } = options;
        const from = 'personalOrg';
        try {
            const params = await this.common.getSyncServerParams({
                from,
                force,
                isMainAccount,
                _account,
            });
            const url = this.ctx.systemApi.getUrl(this.common.getServerUrl(from, params));
            const { personContactGroupList: list = [], lastUpdateTime } = await this.common.excuteContactServerWithRetry({ url, params, isMainAccount, _account }, force ? {} : { correctCodes: [0, 106000, 107000] });
            await this.ctx.contactDB.personalOrgAllInto({
                force,
                list,
                isMainAccount,
                _account,
            });
            this.ctx.contactUtil.setStoreContactSyncPageInfo({
                from,
                domain: this.common.getDomain(_account) || '',
                step: force ? 'all' : 'increase',
                done: true,
                source: 'unknown',
                lastUpdateTime,
                isMainAccount,
                _account,
            });
            return {
                success: true,
                data: [],
                from,
                count: lodashGet(list, 'length', 0),
            };
        }
        catch (ex) {
            return {
                from,
                success: false,
                data: [],
                message: ex instanceof Error ? ex.message : `${ex}`,
            };
        }
    }
    transPersonalOrgToGroup(orgIdList) {
        if (Array.isArray(orgIdList)) {
            return orgIdList.map(orgId => orgId.replace('personal_org_', ''));
        }
        return orgIdList.replace('personal_org_', '');
    }
    resetContact() {
        try {
            this.ctx.store.del(this.common.lastSyncTimeKeyMap.enterprise).then().catch(console.warn);
            this.ctx.store.del(this.common.lastSyncTimeKeyMap.client).then().catch(console.warn);
            this.ctx.store.del(this.common.lastSyncTimeKeyMap.org).then().catch(console.warn);
            this.ctx.store.del(this.common.lastSyncTimeKeyMap.personal).then().catch(console.warn);
        }
        catch (e) {
            console.warn('[contact] reset all sync timestamp', e);
        }
    }
    async deletePersonalContact(_params) {
        const { _account } = _params, params = __rest(_params, ["_account"]);
        const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('deleteContact'), params, {
            _account,
            timeout: 90 * 1000,
        });
        return data;
    }
    async updatePersonalContact(_params) {
        const { _account, params } = _params;
        const groupIdList = (params.groupIdList || []).map(item => this.transPersonalOrgToGroup(item));
        const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('updateContact'), Object.assign(Object.assign({}, params), { emailList: this.common.normalizeEmailList(params.emailList), groupIdList: groupIdList.join(',') }), {
            _account,
        });
        return data;
    }
    async insertPersonalContact(_params) {
        const { list, _account } = _params;
        const params = (Array.isArray(list) ? list : [list]).map(item => (Object.assign(Object.assign({}, item), { emailList: this.common.normalizeEmailList(item.emailList), groupIdList: (item.groupIdList || []).map(groupId => this.transPersonalOrgToGroup(groupId)), auto: item.auto ? 1 : 0 })));
        const additionalParam = params[0]._account ? this.ctx.contactUtil.getAccountSession(params[0]._account) : undefined;
        const baseUrl = this.ctx.systemApi.getUrl('insertContactBatch');
        const url = this.ctx.http.buildUrl(baseUrl, Object.assign({}, additionalParam), {});
        const res = await this.ctx.http.post(url, params, {
            _account,
            contentType: 'json',
        });
        return res.data;
    }
    async insertPersonalOrg(params) {
        const { groupName, idList, marked, _account } = params;
        const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('insertPersonalOrg'), {
            groupName,
            accountIdList: idList,
            marked,
        }, {
            _account,
            contentType: 'json',
        });
        if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
            return {
                success: true,
                data: data.data,
            };
        }
        return {
            success: false,
            message: data === null || data === void 0 ? void 0 : data.message,
        };
    }
    async updatePersonalOrg(params) {
        const { orgId, groupName, idList = [], marked = undefined, _account } = params;
        const groupId = this.transPersonalOrgToGroup(orgId);
        const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('updatePersonalOrg'), {
            groupId,
            groupName,
            accountIdList: idList,
            marked,
        }, {
            _account,
            timeout: 90 * 1000,
            contentType: 'json',
        });
        if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
            return {
                success: true,
                data: data.data,
            };
        }
        return {
            success: false,
        };
    }
    async insertPersonalContactByPersonalOrgId(params) {
        const { orgIdList, idList: accountIdList, _account } = params;
        const groupIdList = this.transPersonalOrgToGroup(orgIdList);
        const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('addPersonToPersonalOrg'), {
            groupIdList,
            accountIdList,
        }, {
            _account,
            timeout: 90 * 1000,
            contentType: 'json',
        });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return {
                success: true,
            };
        }
        return {
            success: false,
            message: data === null || data === void 0 ? void 0 : data.message,
        };
    }
    async deletePersonalOrg(params) {
        const { orgIdList, deletePersonContact, _account } = params;
        const groupIdList = this.transPersonalOrgToGroup(orgIdList);
        const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('deletePersonalOrg'), {
            groupIdList,
            deletePersonContact,
        }, {
            _account,
            contentType: 'json',
            timeout: 90 * 1000,
        });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return {
                success: true,
            };
        }
        return {
            success: false,
            message: data === null || data === void 0 ? void 0 : data.message,
        };
    }
    async uploadIcon(params) {
        var _a;
        const fileFormData = new FormData();
        fileFormData.append('file', params.file, params.fileName);
        const data = await this.ctx.http.post(this.ctx.systemApi.getUrl('uploadIcon'), fileFormData, {
            _account: ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
            headers: {
                'Content-Type': 'multipart/form-data',
                accept: '*/*',
            },
            timeout: 20 * 60 * 1000,
            contentType: 'stream',
        });
        if (!(data === null || data === void 0 ? void 0 : data.data)) {
            return { success: false, message: '请求失败' };
        }
        return data.data;
    }
    async deleteAvartIcon() {
        return this.ctx.http.post(this.ctx.systemApi.getUrl('deleteAvatarIcon'), {});
    }
    async personContactImport(params) {
        var _a;
        try {
            const fileFormData = new FormData();
            fileFormData.append('file', params.file);
            fileFormData.append('fileSize', params.fileSize.toString());
            if (params.groupId) {
                const groupId = this.transPersonalOrgToGroup(params.groupId);
                fileFormData.append('groupId', groupId);
            }
            fileFormData.append('fileType', params.fileType.toString());
            fileFormData.append('type', params.type.toString());
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('personContactImport'), fileFormData, {
                _account: (_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    accept: '*/*',
                },
                timeout: 30 * 60 * 1000,
                contentType: 'stream',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
                return {
                    success: true,
                    data: data.data.personContactVOList,
                };
            }
            console.warn('[contact_server] personContactImport warn', data);
            return {
                success: false,
                code: data === null || data === void 0 ? void 0 : data.code,
                message: data === null || data === void 0 ? void 0 : data.message,
            };
        }
        catch (e) {
            console.error('[contact_server] personContactImport error', e);
            return {
                success: false,
                message: this.ctx.contactUtil.catchError(e),
            };
        }
    }
    async personContactExport(params) {
        var _a;
        try {
            const { groupId, fileType } = params;
            let _groupId = groupId;
            if (groupId) {
                _groupId = this.transPersonalOrgToGroup(groupId);
            }
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('personContactExport'), {
                groupId: _groupId,
                fileType,
            }, {
                _account: ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return {
                    success: true,
                    data: data.data.downloadUrl,
                };
            }
            return {
                success: false,
                code: data === null || data === void 0 ? void 0 : data.code,
                message: data === null || data === void 0 ? void 0 : data.message,
            };
        }
        catch (e) {
            return {
                success: false,
                message: this.ctx.contactUtil.catchError(e),
            };
        }
    }
    async personContactExportTemplate(type = 1) {
        try {
            const { data } = await this.ctx.http.get(this.ctx.systemApi.getUrl('personContactExportTemplate'));
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                const url = type === 1 ? 'csvTemplateUrl' : 'vcfTemplateUrl';
                return {
                    success: true,
                    data: data.data[url],
                };
            }
            return {
                success: false,
                code: data === null || data === void 0 ? void 0 : data.code,
                message: data === null || data === void 0 ? void 0 : data.message,
            };
        }
        catch (e) {
            return {
                success: false,
                message: this.ctx.contactUtil.catchError(e),
            };
        }
    }
    async batchOperatePersonalMark(params) {
        const url = this.ctx.systemApi.getUrl('addPersonalMark');
        const { operateList: _operateList, _account } = params;
        const operateList = _operateList.map(item => {
            if (item.type === '2') {
                item.id = item.id.replace('personal_org_', '');
            }
            return item;
        });
        try {
            const { data } = await this.ctx.http.post(url, {
                operateList,
            }, {
                _account,
                contentType: 'json',
            });
            const { code, error, errorCode } = data;
            return {
                success: code === 200,
                msg: code === 200 ? 'ok' : error,
                errorCode: code === 200 ? 0 : errorCode,
            };
        }
        catch (ex) {
            return {
                success: false,
                msg: lodashGet(ex, 'message', typeof ex === 'string' ? ex : ''),
                errorCode: 'unknown',
            };
        }
    }
}
